/**
 * @file Live Ticker Factory
 *
 * @author christian.sany@notch-interactive.com
 */

import Vue from 'vue/dist/vue.min.js';

let defaults = {
    pollingIntervalAttr: 'data-polling-interval',
    pollingInterval: 3000   // in milliseconds
};

export default (el, options) => {
    if (!el instanceof HTMLElement) {
        return;
    }

    let settings = Object.assign({}, defaults, options);

    // override settings if options on elements available
    if (el.hasAttribute(settings.pollingIntervalAttr)) {
        settings.pollingInterval = Number(el.getAttribute(settings.pollingIntervalAttr));
    }

    const instance = {},
        addTrailingZero = (number) => String(number).length < 2 ? '0' + String(number) : number;

    let itemsToRemove = [],
        removedIds = [];

    instance.vueInstance = new Vue({
        el: el,
        delimiters: ['[[', ']]'],
        data: {
            items: []
        },
        computed: {
            sortedItems() {
                return this.items.sort((a, b) => {
                    return (a.dateTime - b.dateTime) * -1;
                });
            }
        },
        methods: {

            /**
             * Converts a unixTimestamp to time
             *
             * @param {number} dateTime - as unix timestamp
             * @return {string} time
             */
            getTime(dateTime) {

                // Convert unixtimestamp to js compatible timestamp (convert to miliseconds)
                let d = new Date(dateTime * 1000);
                return d.getHours() + ':' + addTrailingZero(d.getMinutes());
            },

            linkTarget(blank) {
                if (blank) {
                    return '_blank';
                } else {
                    return false;
                }
            },

            /**
             * When an Item has entered, the check gets execute if all items can be placed in the container.
             * If the check failes, the Items which don't have enough space in the ticket will be faded out and saved in an array to be removed later
             */
            enterHook() {
                const dontFit = [],
                    parentHeight = this.$refs.list.$el.parentNode.offsetHeight;

                // Check if list is bigger than containing div
                if (this.$refs.list.$el.offsetHeight > parentHeight) {

                    Array.from(this.$refs.list.$el.childNodes).reduce((height, el) => {
                        height = height + el.offsetHeight;

                        if (height > parentHeight) {
                            dontFit.push(el);
                        }

                        return height;
                    }, 0);

                    if (dontFit.length) {
                        dontFit.forEach((el) => {
                            el.style.opacity = 0;
                            itemsToRemove.push(el.getAttribute('data-id'));
                        });
                    }
                }
            },

            /**
             * Removes the faded out items after the enter animation is finished
             * This has to be done, since removing items while the enter transition is running, will abruptly end the enter transition
             */
            afterEnterHook() {
                if (itemsToRemove.length) {

                    this.items = this.items.filter((item) => {
                        return itemsToRemove.indexOf(item.id.toString()) < 0;
                    });

                    itemsToRemove.forEach((item) => {
                        removedIds.indexOf(item) < 0 ? removedIds.push(item) : '';
                    });

                    // Clean the array
                    itemsToRemove = [];
                }
            },

            /**
             * Fetches the newsticker items
             */
            fetchItems() {
                let self = this;

                fetch(window.DS.apis.liveTicker + '?lang=' + window.DS.lang)
                    .then((res) => res.json())
                    .then((json) => {
                        let ids = self.items.map(el => el.id.toString());

                        // Only push new items into the items array and items that aren't already removed
                        json.items
                            .filter(el => ids.indexOf(el.id.toString()) < 0 && removedIds.indexOf(el.id.toString()) < 0)
                            .forEach(el => self.items.push(el));
                    })
                    .catch((error) => {
                        throw new Error(error);
                    });
            }
        },

        /**
         * The created lifecycle hook
         * Calls the original fetch for the news items and begins the fetch interval
         */
        created() {

            this.fetchItems();

            setInterval(this.fetchItems, settings.pollingInterval);

            // USED FOR DEBUGGING AND TESTING
            // let self = this;
            // let i = 0;
            // setInterval(() => {
            //     i = i + 60;
            //     self.items.push({
            //         'id': 1234512 + i,
            //         'dateTime': 1492171260 + i,
            //         'title': 'Spiezathlon 2017',
            //         'desc': 'Kein Schwimmen. Start Duathlon um 14:00 Uhr?',
            //         'cta': 'http://datasport.ch',
            //         'blank': true
            //     });
            // }, 3000);
        }
    });

    return instance;
};
